const state = {
  accessToken: '',
};

export default state;
